import {request, parseEndpoint, format} from "./_utils";
import {pluck} from "../utils";

const supportedEndpoints = new Set(['aggregations','balances','benefits','identities','lists','profile','rewards','transactions'])
export default class RequestHandler {
	constructor(client_id, baseUrl, token, store, log, eventManager){
        this.log = log;
        this.eventManager = eventManager;
        this.client_id = client_id;
        this.store = store;  
        this.request = new request(`${baseUrl}/api/v1/profiles/me`, token);
        this.hydrated = new Set();
    }   
    
    hydrate(path){
        try{ 
            let state = this.store.get(path);
            if(!state || !state.hasOwnProperty('init')){
                throw("This resource can not be hydrated")
            }

            if(this.hydrated.has(path)){return}
            this.hydrated.add(path);

            if(state.init){
                this.eventManager.handler(`shapes.${path}.ready`, {...state})
                this.doRequest('get', path, false, true);
            }else{
                this.doRequest('hydrate', path, false, true);
            }
        }catch(e){
            this.log('error', path, e); 
        }
    }

    get(...args){return this.doRequest('get', ...args)}
    put(...args){return this.doRequest('put', ...args)}
    post(...args){return this.doRequest('post', ...args)}
    delete(...args){return this.doRequest('delete', args[0], false, args[1])}

    doRequest(method, path, params, updateState = false){
        const {resource, url, id} = parseEndpoint(path);

        if(updateState){
            if(supportedEndpoints.has(resource)){
                this.store.dispatch({
                    type: resource+'.load',
                    payload: {loading: true}
                }); 
            }else{
                const error = {
                    status: 400,
                    message: "This resource does not support automatic state update. Turn off state update."
                };

                this.log('error', path, error); 
                return new Promise((resolve, reject)=>reject(error))
            }
        }
       
        let requestMethod = method === 'hydrate' ? 'get' : method;
        return this.request[requestMethod](url, params).then(response => {
            if(!updateState){
                return response;
            }

            const data = pluck(response, 'body.data');
            const {type, payload} = format(method, path, data, id);
            this.store.dispatch({type, payload})

            return response;
        }).catch(e=>{
			this.log('error', path, e); 
            throw(e);
        })
    }
}